module.exports = __webpack_public_path__ + "static/img/recommendedHotels.68e4908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkBg/recommendedHotels.jpg
// module id = WiPw
// module chunks = 1